export const stringToNumber = (string: string): number => {
  return Math.round(Number(string) * 10) / 10
}

export const ObjEntries = <
  T extends object,
  K extends keyof T = keyof T,
  V extends T[K] = T[K]
>(
  obj: T
): [K, V][] => Object.entries(obj) as [K, V][]

export const formatTime = (time: number): string => {
  const hours = Math.floor(time / 3600)
  const minutes = Math.floor((time % 3600) / 60)
  const remainingSeconds = time % 60

  if (hours > 0) {
    return `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  } else {
    return `${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  }
}

export const formattedDate = (date: string): string => {
  const parsedDate = new Date(date)

  // Format the date and time separately using the 'en-GB' locale
  const datePart = parsedDate.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  })

  const timePart = parsedDate.toLocaleTimeString('en-GB', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false
  })
  return `${datePart} ${timePart}`
}

export const getQuestionFromId = (question_id: string): string => {
  return question_id
}

export const formatPhoneNumber = (number: number | string) => {
  // Remove all non-numeric characters
  const cleaned = ('' + number).replace(/\D/g, '')

  // Check if the input is of correct length
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)

  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`
  }

  return number
}

// Helper function to truncate long emails
export const truncateText = (text: string, maxLength: number = 20) => {
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text
}

export const formatSecondsToMinutes = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
}

export const percentage = (value: number, total: number): number => {
  return (value / total) * 100
}

export const formattedDateByHours = (date: number): string => {
  const newDate = formatTime(date)

  return newDate.length > 5
    ? newDate.slice(0, -3) || '0:00'
    : ` 0:${newDate.slice(0, -3) || '0:00'} `
}

export const roundToTwoDecimals = (num: number): number => {
  return Math.round((num + Number.EPSILON) * 100) / 100
}

export const removeHtmlTags = (str: string) => {
  return str.replace(/<\/?[^>]+(>|$)/g, '')
}
